import React from 'react';
import IconContents from './IconContents';
import AvatarContents from './AvatarContents';
import IntegrationContents from './IntegrationContents';
import LinkContents from './LinkContents';
import PillContents from './PillContents';
import ProgressContents from './ProgressContents';
import TagsContents from './TagsContents';
import TextContents from './TextContents';
import { type FieldContentsData } from 'javascripts/shared-types';
import PrefixContents from './PrefixContents';

const ContentComponents = {
  icon: IconContents,
  avatar: AvatarContents,
  integrations: IntegrationContents,
  link: LinkContents,
  pill: PillContents,
  progress: ProgressContents,
  tags: TagsContents,
  prefix: PrefixContents,
  text: TextContents,
};

type FieldContentsProps = {
  // The contents for the fields generated for a given record.
  contents: FieldContentsData;
};

const FieldContents: React.FC<FieldContentsProps> = ({ contents }) => {
  let fieldContents = Object.keys(ContentComponents).map(key => {
    if (!(key in contents)) {
      return null;
    }

    const ContentComponent = ContentComponents[key];
    return (
      <ContentComponent
        key={key}
        contents={contents}
        {...{ [key]: contents[key] }}
      />
    );
  });

  fieldContents = fieldContents.filter(Boolean);

  if (fieldContents.length) {
    const { nowrap, titleStyle } = contents;

    let cardClass = '';
    if (titleStyle) {
      cardClass = 'title-field';
    }

    return (
      <aha-card-field class={cardClass} nowrap={nowrap}>
        {fieldContents}
      </aha-card-field>
    );
  }

  return null;
};

export default FieldContents;
